// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {DigitalUserSearchError} from './digital-user-search-error';

export const ApplicationStatus = t.struct({
    digitalUserSearchError: DigitalUserSearchError,
    hasInitialized: t.Boolean,
    hasSearchStarted: t.Boolean,
    isInitializing: t.Boolean,
    isViewResultsLoading: t.Boolean
}, {
    defaultProps: {
        digitalUserSearchError: new DigitalUserSearchError({}),
        hasInitialized: false,
        hasSearchStarted: false,
        isInitializing: false,
        isViewResultsLoading: false
    },
    name: 'DigitalUserApplicationStatus',
    strict: true
});
